<template>
  <div>
    <template v-if="galleries.length > 0">
      <div v-for="gallery in galleries" :key="gallery.id">
<!--        <pre style="color: white">{{ gallery }}</pre>-->
        <Gallery :gallery-type="galleryType" :gallery="gallery" />
      </div>
    </template>
  </div>
</template>


<script>

import Gallery from "@/domain/galleries/Gallery.vue";

export default {
  name: 'FavoriteGalleries',
  components: {Gallery},
  props: {
    galleries: {
      type: Array,
      required: true
    },
    galleryType: {
      type: String,
      required: true
    }
  }
}
</script>
